export const NEW_FILE = 'new_file';
export const DEFAULT_FILE = 'main.liquid';
